import React, { useEffect, useState, useRef } from 'react';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { convertToHebrew } from 'jewish-dates-core';
import { getLocalStorage, setLocalStorage } from '../../utils/localStorage';
import { fetchData } from '../../utils/http';

import './classText.scss';

const HEADLINES = {
  1: 'הקדמת הרמב"ם',
  2: 'מצוות עשה',
  3: 'מצוות לא תעשה',
  4: 'מנין המצוות לפי סדר הלכות',
};

export default function ClassText({ track, classNum }) {

  const [text, setText] = useState([]);
  const [textToDisplay, setTextToDisplay] = useState([]);
  const [fontSize, setFontSize] = useState(+getLocalStorage('fs') || 20);
  const currTrack = useRef('');

  useEffect(() => {
    if (classNum !== 0) {
      setText([]);
      fetchData(`class/get-rambam-text?&classNum=${classNum}&track=${track}`)
        .then((res) => {
          setText(res.data?.text);
          currTrack.current = track;
        })
        .catch((err) => {
          if (err) console.log(err);
        });
    }
  }, [classNum, track]);
  useEffect(() => {
    setTextToDisplay(text);

    if (text.length && track === 'three' && [1, 2, 3, 4].includes(+classNum)) {
      const merged = text.reduce((acc, obj, index) => {
        if (index === 0) {
          acc = { ...obj, text: JSON.parse(obj.text) }; // Copy the first object
        } else {
          acc.text = acc.text.concat(JSON.parse(obj.text)); // Merge text arrays
        }
        return acc;
      }, {});
      merged.text = JSON.stringify(merged.text);
      merged.chapter_description = HEADLINES[classNum];
      console.log(merged);
      setTextToDisplay([merged]);
    }
  }, [text]);
  function incrementFontSize() {
    setFontSize((fs) => ++fs);
    setLocalStorage({ fs: fontSize + 1 });
  }

  function decrementFontSize() {
    setFontSize((fs) => --fs);
    setLocalStorage({ fs: fontSize - 1 });
  }
  return (
    <>
      <Box className="font-size-ctrl">
        <IconButton
          variant="contained"
          color="primary"
          onClick={incrementFontSize}
        >
          <AddIcon />
        </IconButton>
        <Box minWidth={90} textAlign="center">
          גודל טקסט
        </Box>
        <IconButton
          variant="contained"
          color="primary"
          onClick={decrementFontSize}
        >
          <RemoveIcon />
        </IconButton>
      </Box>
      <Box className="class-text">
        {text.length > 0 &&
          currTrack.current !== 'sefer' &&
          textToDisplay.map((ch, i) => (
            <Box
              className="chapter"
              key={ch.book_english + ch.chapter}
              fontSize={fontSize}
            >
              {ch.opening && (
                <Box
                  className="opening"
                  dangerouslySetInnerHTML={{ __html: ch.opening }}
                ></Box>
              )}
              <Box marginBottom={2} fontWeight={600}>
                {ch.chapter_description ? (
                  <span>
                    {ch.laws}: {ch.chapter_description}
                  </span>
                ) : (
                  <span>
                    {ch.laws} - פרק {convertToHebrew(ch.chapter)}
                  </span>
                )}
              </Box>
              {JSON.parse(ch.text).map((ha, x) => (
                <Box display="flex" gap={1} key={x + ha.substring(0, 10)}>
                  <Box minWidth={22}>
                    {(() => {
                      if (
                        ([1, 4].includes(+classNum) && track === 'three') ||
                        ha.startsWith('<small>') ||
                        x > 364
                      ) {
                        return '';
                      } else {
                        return convertToHebrew(x + 1, false, false) + '.';
                      }
                    })()}
                  </Box>
                  <Box
                    className="halacha"
                    dangerouslySetInnerHTML={{ __html: ha }}
                  ></Box>
                </Box>
              ))}
            </Box>
          ))}
        {text.length > 0 &&
          currTrack.current === 'sefer' &&
          textToDisplay.map((m, i) => (
            <Box
              className="chapter"
              key={m.mitzva + m.mitzva_num}
              fontSize={fontSize}
            >
              <Box marginBottom={2} fontWeight={600}>
                {m.mitzva} - {m.mitzva_num}
              </Box>
              {!m.text.startsWith('[') ? (
                <Box
                  className="halacha"
                  dangerouslySetInnerHTML={{ __html: m.text }}
                ></Box>
              ) : (
                JSON.parse(m.text).map((ha, x) => (
                  <Box display="flex" gap={1} key={x + ha.substring(0, 10)}>
                    <Box minWidth={22}>
                      {ha.startsWith('<small>')
                        ? ''
                        : convertToHebrew(x + 1, false, false) + '.'}
                    </Box>
                    <Box
                      className="halacha"
                      dangerouslySetInnerHTML={{ __html: ha }}
                    ></Box>
                  </Box>
                ))
              )}
            </Box>
          ))}
      </Box>
    </>
  );
}
